import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { FeatureCard } from './FeatureCard';

interface Feature {
  icon: string;
  text: string;
}

interface FeatureGridProps {
  features: Feature[];
  variant?: 'horizontal' | 'vertical';
  withPaper?: boolean;
}

export const FeatureGrid = ({ features, variant = 'horizontal', withPaper = false }: FeatureGridProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid 
      container 
      spacing={{ xs: 1, sm: 2 }} 
      alignItems="center" 
      justifyContent="center" 
      sx={{ 
        mt: { xs: 2, sm: 3 }, 
        maxWidth: 1200, 
        mx: 'auto',
        px: { xs: 1, sm: 2 }
      }}
    >
      {features.map((feature, index) => (
        <Grid 
          size={{xs:12, sm:6, md:4}}    
          key={index}
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <FeatureCard
            icon={feature.icon}
            text={feature.text}
            variant={variant}
            withPaper={withPaper}
          />
        </Grid>
      ))}
    </Grid>
  );
}; 